import { epdOf } from '@chess/api-openings';
import { positionAt, type ReviewState } from '@chess/api-review';

// The named position the opening tab's sections are about: the board's own
// name when the book names it, else the deepest named position of the game.
// Read off the review's book (`state.book`), loaded once per game.

export interface Node {
  epd: string;
  eco: string;
  name: string;
}

/** The opening tab's named position for a review state; undefined until the book is loaded, or when it names nothing. */
export function nodeOf(state: ReviewState): Node | undefined {
  const game = state.game;
  const book = state.book;
  if (!book || !game) return undefined;
  const fen = positionAt(state);
  const current = fen ? book.lookup(fen) : undefined;
  if (fen && current) return { epd: epdOf(fen), ...current };
  if (book.reading) return { epd: epdOf(game.positions[book.reading.ply]), ...book.reading.opening };
  return undefined;
}
